/*
 * Desktop nav dropdown viewport positioning (progressive enhancement).
 *
 * Impulse positions dropdowns with static CSS only (.site-nav__dropdown opens
 * below its trigger; .site-nav__deep-dropdown opens at left:100%/top:0) and
 * assumes menus are short. This script measures on open and, only when the
 * default position would overflow the viewport:
 *   - flips the panel upward via the nav-drop--up class when it fits better, or
 *   - clamps it with a max-height + scroll so it always stays fully visible.
 * Without JS (or before it loads) the stock CSS behavior is unchanged.
 * Mega menus (full-width panels) are intentionally left untouched.
 */
(function () {
  'use strict';

  var MARGIN = 8; // breathing room from viewport edges (px)

  function clearAdjustments(panel) {
    panel.classList.remove('nav-drop--up');
    panel.classList.remove('nav-drop--scroll');
    panel.style.maxHeight = '';
  }

  function position(panel) {
    if (!panel) return;
    clearAdjustments(panel);

    var vh = window.innerHeight;
    var rect = panel.getBoundingClientRect();
    if (rect.height === 0) return;

    // Fits below (default) — nothing to do.
    if (rect.bottom <= vh - MARGIN && rect.top >= MARGIN) return;

    // Try flipping upward and re-measure against the real anchor box.
    panel.classList.add('nav-drop--up');
    var upRect = panel.getBoundingClientRect();
    if (upRect.top >= MARGIN && upRect.bottom <= vh - MARGIN) return;

    // Neither direction fully fits — keep the better one and clamp with scroll.
    var downSpace = vh - MARGIN - rect.top;
    var upSpace = upRect.bottom - MARGIN;
    var useUp = upSpace > downSpace;
    if (!useUp) panel.classList.remove('nav-drop--up');
    panel.classList.add('nav-drop--scroll');
    panel.style.maxHeight = Math.max(useUp ? upSpace : downSpace, 120) + 'px';
  }

  // Second-level dropdowns: <details class="site-nav__details"> toggled by the
  // theme (hover and keyboard both set [open], so 'toggle' covers both paths).
  document.addEventListener('toggle', function (e) {
    var details = e.target;
    if (!details.classList || !details.classList.contains('site-nav__details')) return;
    if (!details.open) return;
    var panel = details.querySelector(':scope > .site-nav__dropdown:not(.megamenu)');
    position(panel);
  }, true);

  // Third-level flyouts open on pure CSS :hover / .is-focused, so hook the
  // trigger row. Evaluate once per hover/focus entry (guard avoids re-running
  // mid-transition on every child mouseover).
  var lastTrigger = null;

  function handleTriggerEnter(target) {
    var trigger = target.closest ? target.closest('.site-nav__deep-dropdown-trigger') : null;
    if (trigger === lastTrigger) return;
    lastTrigger = trigger;
    if (!trigger) return;
    position(trigger.querySelector('.site-nav__deep-dropdown'));
  }

  document.addEventListener('mouseover', function (e) {
    handleTriggerEnter(e.target);
  }, true);

  document.addEventListener('focusin', function (e) {
    handleTriggerEnter(e.target);
  }, true);
})();
